import type { HTMLAttributes } from 'react'
import clsx from 'clsx'

import styles from './SkeletonPrimitives.module.scss'

type SkeletonBaseProps = HTMLAttributes<HTMLDivElement>

export const SkeletonBase = ({
  style,
  className,
  ...rest
}: SkeletonBaseProps) => (
  <div className={clsx(styles.base, className)} style={style} {...rest} />
)

type SkeletonLineProps = SkeletonBaseProps & {
  w: string | number
  h: string | number
}

export const SkeletonLine = ({
  w,
  h,
  style,
  className,
  ...rest
}: SkeletonLineProps) => (
  <div
    className={clsx(styles.base, styles.line, className)}
    style={{ width: w, height: h, ...style }}
    {...rest}
  />
)

type SkeletonSquareProps = SkeletonBaseProps & {
  size: string | number
}

export const SkeletonSquare = ({
  size,
  style,
  className,
  ...rest
}: SkeletonSquareProps) => (
  <div
    className={clsx(styles.base, styles.square, className)}
    style={{ width: size, height: size, ...style }}
    {...rest}
  />
)

export const SkeletonChip = ({
  style,
  className,
  ...rest
}: SkeletonBaseProps) => (
  <div
    className={clsx(styles.base, styles.chip, className)}
    style={style}
    {...rest}
  />
)
